"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAppointmentType = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _utils = require("../utils");
var _reactUse = require("react-use");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SelectAppointmentType = function SelectAppointmentType(_ref) {
  var value = _ref.value,
    onSelect = _ref.onSelect;
  var handleChange = function handleChange(e) {
    var action = e.target.value;
    onSelect(action);
  };

  // Reset appointment type when component is hidden
  (0, _reactUse.useUnmount)(function () {
    onSelect(_utils.AppointmentType.OneOff);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[12px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Radio.Group, {
    name: "selectAppointmentType",
    onChange: handleChange,
    value: value
  }, /*#__PURE__*/_react.default.createElement(_components.Radio, {
    value: _utils.AppointmentType.OneOff
  }, "Schedule one-off appointment"), /*#__PURE__*/_react.default.createElement(_components.Radio, {
    value: _utils.AppointmentType.Recurring
  }, "Schedule recurring appointment")));
};
exports.SelectAppointmentType = SelectAppointmentType;